import { FormlyFieldConfig } from 'ng-formly';
export const filterFields: Array<FormlyFieldConfig> = [
    {
        key: 'filterfield',
        type: 'select-component',
        templateOptions: {
            type: 'filterfield',
            filtering: true,
            label: 'Choose Field',
            required: true,
            options: []
        }
    },
    {
        key: 'filtercondition',
        type: 'select-component',
        hideExpression: '!model.filtertype',
        templateOptions: {
            type: 'filtercondition',
            filter: 'filterfield',
            filtering: true,
            label: 'Choose Condition',
            required: true,
            options: []
        }
    },
    {
        key: 'filtervalueinput',
        type: 'input-field',
        hideExpression: '(!model.filtertype || model.filtertype !== "input" || !model.filtercondition || model.filtercondition === "is between" || model.filtercondition === "empty" || model.filtercondition === "not-empty")',
        templateOptions: {
            type: 'text',
            filtering: true,
            label: 'Enter Value',
            default: ''
        }
    },
    {
        key: 'filtervaluenumberstart',
        type: 'input-field',
        hideExpression: '(!model.filtertype || model.filtertype !== "input" || !model.filtercondition || model.filtercondition !== "is between" || model.filtercondition === "empty" || model.filtercondition === "not-empty")',
        templateOptions: {
            type: 'number',
            filtering: true,
            label: 'Enter Starting Value',
            default: 0
        }
    },
    {
        key: 'filtervaluenumberend',
        type: 'input-field',
        hideExpression: '(!model.filtertype || model.filtertype !== "input" || !model.filtercondition || model.filtercondition !== "is between" || model.filtercondition === "empty" || model.filtercondition === "not-empty")',
        templateOptions: {
            type: 'number',
            filtering: true,
            label: 'Enter Ending Value',
            default: 0
        }
    },
    {
        key: 'filtervalueselect',
        type: 'select-component',
        hideExpression: '(!model.filtertype || model.filtertype !== "select" || !model.filtercondition || model.filtercondition === "is between" || model.filtercondition === "empty" || model.filtercondition === "not-empty")',
        templateOptions: {
            type: 'filtervalue',
            filter: 'filterfield',
            filtering: true,
            label: 'Select Value',
            options: []
        }
    },
    {
        key: 'filtervaluedatestart',
        type: 'input-field',
        hideExpression: '(!model.filtertype || model.filtertype !== "select" || !model.filtercondition || model.filtercondition !== "is between" || model.filtercondition === "empty" || model.filtercondition === "not-empty")',
        templateOptions: {
            type: 'date',
            filtering: true,
            label: 'Select Start Date'
        }
    },
    {
        key: 'filtervaluedateend',
        type: 'input-field',
        hideExpression: '(!model.filtertype || model.filtertype !== "select" || !model.filtercondition || model.filtercondition !== "is between" || model.filtercondition === "empty" || model.filtercondition === "not-empty")',
        templateOptions: {
            type: 'date',
            filtering: true,
            label: 'Select End Date'
        }
    }
];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/filter.ts